import React from 'react';
import { ArticleHeader } from './ArticleHeader';
import { ContentSection } from './ContentSection';
import { CTAButton } from './CTAButton';
import { TestimonialCard } from './TestimonialCard';
import { FAQItem } from './FAQItem';
import { OfferItem } from './OfferItem';
import { PriceComparison } from './PriceComparison';
import { GuaranteeSection } from './GuaranteeSection';
import { FloatingProduct } from './FloatingProduct';
export function LisseaArticle() {
  return <div className="min-h-screen bg-white" data-id="element-45">
      <main className="max-w-5xl mx-auto px-4 py-8 md:py-12 flex items-start gap-12" data-id="element-46">
        {/* Main Article Content */}
        <article className="max-w-2xl w-full mx-auto" data-id="element-47">
          <ArticleHeader data-id="element-48" />

          <div className="article-body" data-id="element-49">
            <ContentSection data-id="element-50">
              <p data-id="element-51">
                <strong data-id="element-52">
                  Si vous êtes une femme de plus de 35 ans et que vous avez
                  l'impression que votre corps a changé sans vous demander la
                  permission…
                </strong>
              </p>
              <p data-id="element-53">Vous n'êtes pas seule.</p>
              <p data-id="element-54">Et surtout — ce n'est pas de votre faute.</p>
              <p data-id="element-55">
                Peut-être que vous avez remarqué que vos cuisses, votre ventre
                ou vos bras ne ressemblent plus à ce qu'ils étaient il y a
                quelques années. Que la texture de votre peau est devenue
                irrégulière, moins ferme, moins lisse.
              </p>
              <p data-id="element-56">
                Peut-être que vous évitez certaines tenues. Que le miroir est
                devenu un moment de jugement plutôt qu'un moment neutre. Que
                l'été approche et que l'idée de porter un maillot de bain vous
                stresse au lieu de vous réjouir.
              </p>
              <p data-id="element-57">Et le pire ?</p>
              <p data-id="element-58">
                <strong data-id="element-59">Vous avez essayé. Vraiment essayé.</strong>
              </p>
              <p data-id="element-60">
                Les crèmes. Les régimes. Le sport. Les appareils trouvés sur
                Internet. Peut-être même des séances professionnelles de
                palper-rouler qui vous ont coûté cher… et laissé des bleus.
              </p>
              <p data-id="element-61">
                Mais au fond, rien n'a vraiment changé de façon durable. Et
                chaque échec a renforcé cette pensée silencieuse :
              </p>
              <p data-id="element-62">
                <em data-id="element-63">
                  "Peut-être que c'est juste mon corps maintenant. Peut-être que
                  je dois accepter."
                </em>
              </p>
              <p data-id="element-64">Non.</p>
              <p data-id="element-65">La vérité, c'est que ce n'est pas votre corps le problème.</p>
              <p data-id="element-66">
                <strong data-id="element-67">C'est la méthode.</strong>
              </p>
            </ContentSection>

            <ContentSection data-id="element-68">
              <h2 className="text-2xl md:text-3xl font-sans font-bold text-gray-900 mt-12 mb-6" data-id="element-69">
                Les 3 pièges qui empêchent votre peau de retrouver sa texture
              </h2>
              <p data-id="element-70">
                La plupart des femmes qui luttent contre la cellulite et la peau
                irrégulière tombent — sans le savoir — dans trois pièges qui
                sabotent leurs résultats avant même de commencer.
              </p>
              <p data-id="element-71">Et une fois que vous les comprenez, tout change.</p>

              <h3 className="text-xl font-sans font-bold text-brand-700 mt-8 mb-4" data-id="element-72">
                Piège nº1 : Croire que c'est un problème de graisse
              </h3>
              <p data-id="element-73">
                C'est l'erreur la plus répandue. Et c'est exactement ce que
                l'industrie veut vous faire croire — parce que ça vend des
                régimes, des crèmes "brûle-graisse" et des programmes
                d'exercices intensifs.
              </p>
              <p data-id="element-74">Mais la réalité est plus nuancée.</p>
              <p data-id="element-75">
                La cellulite et l'aspect irrégulier de la peau ne sont pas
                simplement un excès de graisse. Des femmes minces ont de la
                cellulite. Des femmes sportives aussi. C'est un phénomène qui
                touche entre 85 et 98 % des femmes après la puberté — c'est
                physiologiquement normal.
              </p>
              <p data-id="element-76">
                Alors pourquoi continuez-vous à traiter votre peau comme un
                problème de poids ?
              </p>

              <img src="https://cdn.magicpatterns.com/uploads/4wsRs2qzPeLVc2QWDF2fSw/hf_20260313_120909_ba30e525-523a-4cb7-96c0-21b75953f343.jpg" alt="Texture de la peau" className="w-full h-auto rounded-xl my-8 object-cover" data-id="element-77" />

              <p data-id="element-78">
                Ce qui crée réellement l'aspect "peau d'orange" est un ensemble
                de facteurs sous la surface : la structure du tissu conjonctif,
                la microcirculation ralentie, la rétention de fluides, et une
                texture cutanée qui devient progressivement moins souple avec le
                temps.
              </p>
              <p data-id="element-79">
                En d'autres termes :{' '}
                <strong data-id="element-80">la texture de votre peau est devenue "figée."</strong>{' '}
                Et aucune crème ni aucun régime ne peut atteindre ce qui se
                passe à ce niveau-là.
              </p>

              <h3 className="text-xl font-sans font-bold text-brand-700 mt-8 mb-4" data-id="element-81">
                Piège nº2 : Accepter la douleur comme preuve d'efficacité
              </h3>
              <p data-id="element-82">
                <em data-id="element-83">"Il faut souffrir pour être belle."</em>
              </p>
              <p data-id="element-84">
                Vous avez peut-être entendu cette phrase toute votre vie. Et
                dans le domaine des soins anti-cellulite, elle est devenue
                presque un dogme. Les ventouses qui laissent des bleus pendant
                des jours. Le palper-rouler en institut qui fait serrer les
                dents. Les appareils à aspiration qui éclatent les petits
                vaisseaux.
              </p>
              <p data-id="element-85">
                Beaucoup de femmes acceptent cette douleur parce qu'elles
                pensent que c'est le signe que "ça travaille."
              </p>
              <p data-id="element-86">
                Mais voici ce que personne ne vous dit :{' '}
                <strong data-id="element-87">
                  la douleur et les bleus ne sont pas des signes d'efficacité.
                  Ce sont des signes d'agression.
                </strong>
              </p>
              <p data-id="element-88">
                Quand votre peau est agressée, elle se défend. Elle gonfle. Elle
                s'irrite. Et souvent — elle revient exactement au même état
                qu'avant, parfois pire. Le vrai problème n'a jamais été
                l'intensité. C'est la constance. Mais comment être constante
                avec quelque chose qui fait mal ?
              </p>

              <h3 className="text-xl font-sans font-bold text-brand-700 mt-8 mb-4" data-id="element-89">
                Piège nº3 : Chercher une transformation au lieu d'un rituel
              </h3>
              <p data-id="element-90">C'est le piège le plus subtil. Et le plus destructeur.</p>
              <p data-id="element-91">
                L'industrie de la beauté vous a conditionné à chercher LE
                produit miraculeux. LA transformation. L'avant/après
                spectaculaire. Mais les femmes qui obtiennent de vrais résultats
                durables n'ont jamais cherché une transformation radicale.
              </p>
              <p data-id="element-92">
                <strong data-id="element-93">
                  Elles ont trouvé un rituel simple qu'elles peuvent tenir dans
                  la durée.
                </strong>
              </p>
              <p data-id="element-94">
                Une transformation, c'est un effort ponctuel, intense, souvent
                douloureux… suivi d'un retour à la case départ parce que ce
                n'était pas tenable. Un rituel, c'est un geste doux, intégré
                dans votre quotidien, qui crée des changements progressifs —
                parce que vous le faites réellement. Jour après jour. Sans vous
                forcer.
              </p>
              <p data-id="element-95">
                La question n'a jamais été{' '}
                <em data-id="element-96">"est-ce que vous avez assez de discipline ?"</em> La
                question, c'est : est-ce que ce qu'on vous a proposé jusqu'ici
                était réaliste pour votre vie ?
              </p>
            </ContentSection>

            <ContentSection data-id="element-97">
              <div className="bg-brand-50 border-l-4 border-brand-500 p-6 rounded-r-xl my-10" data-id="element-98">
                <h2 className="text-xl font-sans font-bold text-gray-900 mb-4" data-id="element-99">
                  Ce qui se passe réellement sous votre peau
                </h2>
                <p className="mb-4" data-id="element-100">
                  Si ce n'est ni un problème de graisse, ni un manque d'effort,
                  ni un manque de discipline… alors qu'est-ce qui se passe
                  vraiment ?
                </p>
                <p className="mb-4" data-id="element-101">
                  La réponse se trouve sous la surface de votre peau. Ce que la
                  recherche montre, c'est que l'aspect irrégulier de la peau est
                  largement lié à deux phénomènes silencieux :
                </p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-102">
                  <li data-id="element-103">
                    <strong data-id="element-104">Une microcirculation endormie :</strong> Les fluides
                    stagnent. La surface de la peau perd sa souplesse et son
                    grain naturel.
                  </li>
                  <li data-id="element-105">
                    <strong data-id="element-106">Une texture cutanée "verrouillée" :</strong> La peau
                    est structurellement figée dans un état irrégulier. Sans
                    stimulation adaptée, elle reste dans cet état.
                  </li>
                </ul>
                <p className="mb-0" data-id="element-107">
                  C'est ce qu'on appelle le phénomène de{' '}
                  <strong data-id="element-108">"Circulation Dormante + Texture Verrouillée."</strong>
                </p>
              </div>

              <p data-id="element-109">
                C'est exactement la raison pour laquelle tout ce que vous avez
                essayé n'a jamais donné de résultats durables : aucune de ces
                méthodes ne s'adressait au vrai problème.
              </p>
              <p data-id="element-110">
                Les crèmes restent en surface. Les régimes s'attaquent à la
                graisse, pas à la texture. Les appareils douloureux agressent au
                lieu de stimuler.
              </p>
              <p data-id="element-111">
                Il y a une différence fondamentale entre comprimer la peau par
                la pression ou l'aspiration — ce qui crée un effet temporaire de
                surface et souvent des bleus — et{' '}
                <strong data-id="element-112">
                  stimuler les tissus par des micro-vibrations haute fréquence
                </strong>
                , qui pénètrent plus en profondeur sans exercer de force
                mécanique agressive.
              </p>
              <p data-id="element-113">
                C'est la différence entre frapper à une porte et la défoncer.
                Les deux produisent un effet — mais un seul ne détruit pas la
                porte.
              </p>
              <p data-id="element-114">
                Les micro-vibrations agissent comme un signal doux et répété qui
                "réapprend" aux tissus à fonctionner normalement :
                microcirculation relancée, fluides remis en mouvement, texture
                progressivement assouplie. Sans dommage. Sans inflammation.
              </p>
            </ContentSection>

            <ContentSection data-id="element-115">
              <h2 className="text-2xl md:text-3xl font-sans font-bold text-gray-900 mt-12 mb-6" data-id="element-116">
                "Je faisais tout bien… mais rien ne changeait"
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/7bM6j8U7NEWRc43HAmJ21d/hf_20260313_123322_d6ec4512-67aa-4568-a294-1259ef6d919a.jpg" alt="Les méthodes qui ne fonctionnent pas" className="w-full h-auto rounded-xl my-8 object-cover" data-id="element-117" />

              <p data-id="element-118">
                Marie a 48 ans. Mère de deux enfants. Elle travaille à temps
                plein dans un cabinet médical à Lyon. Comme beaucoup de femmes
                de son âge, elle a commencé à remarquer des changements dans son
                corps vers 40 ans. La texture de ses cuisses. L'aspect de son
                ventre. Ses bras qui n'étaient plus les mêmes.
              </p>
              <p data-id="element-119">
                Elle a essayé une crème anti-cellulite recommandée par une amie.
                Résultat : rien de visible après deux tubes. Elle s'est inscrite
                à un cours de sport. Résultat : plus de tonus, mais la texture
                de sa peau n'a pas changé. Elle a tenté les ventouses. Résultat
                : des bleus sur les cuisses pendant une semaine.
              </p>
              <p data-id="element-120">Et à chaque fois, la même pensée revenait :</p>
              <p data-id="element-121">
                <em data-id="element-122">
                  "Je fais tout bien. Pourquoi est-ce que rien ne change ?"
                </em>
              </p>
              <p data-id="element-123">
                Mais Marie n'a pas abandonné. Elle a juste changé de question.
                Au lieu de se demander "qu'est-ce que je fais mal ?", elle s'est
                demandée :
              </p>
              <p data-id="element-124">
                <strong data-id="element-125">
                  "Et si ce n'était pas un problème d'effort… mais un problème
                  de méthode ?"
                </strong>
              </p>
              <p data-id="element-126">
                Un soir, en parcourant un forum français, Marie est tombée sur
                un commentaire d'une femme qui décrivait exactement ce qu'elle
                cherchait : un résultat réaliste, une méthode simple, une
                routine qu'elle pouvait réellement tenir.
              </p>
              <p data-id="element-127">
                Marie a découvert une approche basée sur les micro-vibrations.
                Pas de douleur. Pas de bleus. Pas de séances de 45 minutes. Un
                geste de 5 minutes. Le soir, devant la télé.
              </p>
              <p data-id="element-128">Ce qui s'est passé dans les 7 premiers jours l'a surprise.</p>
              <p data-id="element-129">
                Non, elle ne s'est pas réveillée avec un corps différent. Mais
                sa peau était différente au toucher. Plus douce. Plus lisse.
                Plus uniforme. Là où avant elle sentait cette texture granuleuse
                sous ses doigts, elle sentait maintenant une surface plus
                souple, plus vivante.
              </p>
              <p data-id="element-130">
                <em data-id="element-131">
                  "Pour la première fois, je n'avais pas besoin de me forcer.
                  Mon corps me donnait une raison de continuer."
                </em>
              </p>
            </ContentSection>

            <div className="flex justify-center my-12" data-id="element-132">
              <CTAButton href="https://barkvee.com/products/lissea" data-id="element-133">
                Découvrir cette méthode →
              </CTAButton>
            </div>

            <ContentSection data-id="element-134">
              <h2 className="text-3xl md:text-4xl font-sans font-extrabold text-gray-900 mt-16 mb-8 text-center" data-id="element-135">
                Voici Lissea™
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/wDA81QL7oUdyT7dKdNT7zL/hf_20260313_142719_2d88c4a5-9345-4046-8603-a8f9b1d4c618.jpg" alt="Lissea Device" className="w-full h-auto rounded-2xl shadow-lg mb-8 object-cover" data-id="element-136" />

              <p data-id="element-137">
                Voici Lissea™ — un appareil de soin corporel à
                micro-vibrations, conçu spécifiquement pour les femmes qui
                veulent améliorer la texture de leur peau et retrouver une
                silhouette plus harmonieuse, chez elles, en quelques minutes par
                jour.
              </p>
              <p data-id="element-138">
                Lissea™ n'est pas un énième gadget qui promet de "brûler les
                graisses" ou de "sculpter votre corps en 7 jours." C'est un
                outil de rituel quotidien. Il a été pensé autour d'un principe
                simple mais puissant :
              </p>
              <p className="text-xl font-sans font-bold text-brand-600 text-center my-8" data-id="element-139">
                Réveiller la peau plutôt que la forcer à changer.
              </p>
              <p data-id="element-140">
                Grâce à ses micro-vibrations haute fréquence, Lissea™ agit en
                douceur sur la surface de la peau et les tissus sous-jacents
                pour :
              </p>
              <ul className="list-none space-y-4 my-6" data-id="element-141">
                <li className="flex items-start gap-3" data-id="element-142">
                  <span className="text-brand-500 mt-1" data-id="element-143">→</span>
                  <span data-id="element-144">
                    <strong data-id="element-145">Stimuler la microcirculation</strong> dans les zones
                    où elle s'est ralentie avec le temps — cuisses, ventre,
                    bras, fesses.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-146">
                  <span className="text-brand-500 mt-1" data-id="element-147">→</span>
                  <span data-id="element-148">
                    <strong data-id="element-149">Aider à libérer la texture cutanée</strong> de cet
                    état "figé" qui donne l'aspect irrégulier et granuleux.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-150">
                  <span className="text-brand-500 mt-1" data-id="element-151">→</span>
                  <span data-id="element-152">
                    <strong data-id="element-153">Favoriser une peau plus lisse</strong>, plus douce
                    et plus uniforme — progressivement, à chaque utilisation.
                  </span>
                </li>
              </ul>
              <p data-id="element-154">
                Et surtout — il fait tout ça sans douleur. Sans bleus. Sans
                agression. C'est une vibration douce, précise, presque apaisante
                — qui transforme votre rituel du soir en un moment pour vous.
              </p>
            </ContentSection>

            <ContentSection data-id="element-155">
              <h2 className="text-2xl md:text-3xl font-sans font-bold text-gray-900 mt-12 mb-8" data-id="element-156">
                Le Protocole Texture Lissea™ (Comment ça fonctionne)
              </h2>

              <div className="space-y-8" data-id="element-157">
                <div data-id="element-158">
                  <h3 className="text-xl font-sans font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-159">
                    <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-160">
                      1
                    </span>
                    Activation de la Micro-Circulation
                  </h3>
                  <p data-id="element-161">
                    Les micro-vibrations haute fréquence de Lissea™ agissent
                    comme un "réveil" pour la microcirculation dans les zones
                    ciblées. Quand la circulation est stimulée, les fluides qui
                    stagnent sous la surface commencent à se remettre en
                    mouvement.
                  </p>
                </div>

                <div data-id="element-162">
                  <h3 className="text-xl font-sans font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-163">
                    <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-164">
                      2
                    </span>
                    Libération de la Texture
                  </h3>
                  <p data-id="element-165">
                    Avec une utilisation régulière, les micro-vibrations aident
                    la texture de la peau à se "déverrouiller" progressivement.
                    L'aspect granuleux commence à s'atténuer. Non pas parce que
                    vous forcez votre peau, mais parce que vous lui donnez la
                    stimulation douce dont elle a besoin.
                  </p>
                </div>

                <div data-id="element-166">
                  <h3 className="text-xl font-sans font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-167">
                    <span className="bg-brand-100 text-brand-700 w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-168">
                      3
                    </span>
                    Le Système de Consistance Sans Friction
                  </h3>
                  <p data-id="element-169">
                    La plupart des solutions échouent car elles sont trop
                    contraignantes. Lissea™ a été conçu pour éliminer toutes
                    les excuses : 5 minutes par jour. Aucune douleur. Utilisable
                    partout (devant la télé, en écoutant un podcast). Aucune
                    installation compliquée.
                  </p>
                </div>
              </div>

              <img src="https://cdn.magicpatterns.com/uploads/ew4ePJtFnWcHyPL2QVrzjQ/hf_20260313_130806_6028f4ad-55d4-4239-8eee-a43b042716e2.jpg" alt="Utilisation relaxante sur le canapé" className="w-full h-auto rounded-xl my-10 object-cover" data-id="element-170" />
            </ContentSection>

            <ContentSection className="bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-171">
              <h2 className="text-2xl font-sans font-bold text-gray-900 mb-6" data-id="element-172">
                Ce que Lissea™ n'est PAS (Soyons directs)
              </h2>
              <p data-id="element-173">
                Si vous lisez encore cette page, vous avez probablement une
                pensée en tête : <em data-id="element-174">"Encore un gadget…"</em> Vous avez raison
                d'être méfiante. Alors voici ce que Lissea™ n'est pas :
              </p>
              <ul className="space-y-4 mt-6" data-id="element-175">
                <li data-id="element-176">
                  ❌ <strong data-id="element-177">Pas un appareil "brûle-graisse".</strong> Aucun
                  appareil ne brûle la graisse à votre place. Lissea™ agit sur
                  la texture et la microcirculation.
                </li>
                <li data-id="element-178">
                  ❌ <strong data-id="element-179">Pas un traitement médical.</strong> C'est un outil
                  de soin corporel quotidien — un rituel, pas un médicament.
                </li>
                <li data-id="element-180">
                  ❌ <strong data-id="element-181">Pas de résultats miraculeux.</strong> Pas de
                  "perdez 3 tailles en une semaine." Les résultats sont
                  progressifs et réalistes.
                </li>
                <li data-id="element-182">
                  ❌ <strong data-id="element-183">Ça ne fait pas mal.</strong> Si votre définition de
                  "ça marche" inclut des bleus, cet appareil n'est pas fait pour
                  vous.
                </li>
              </ul>
            </ContentSection>

            <ContentSection data-id="element-184">
              <h2 className="text-2xl md:text-3xl font-sans font-bold text-gray-900 mt-16 mb-8 text-center" data-id="element-185">
                Ce que les femmes disent réellement
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/muMbyJphuWSg5Nbn4671ZG/hf_20260313_125433_e4d38915-30c3-4834-93a7-80b993dd696c.png" alt="Peau douce et hydratée" className="w-full h-auto rounded-xl mb-10 object-cover" data-id="element-186" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-187">
                <TestimonialCard avatarUrl="https://randomuser.me/api/portraits/women/52.jpg" name="Sophie" age={52} city="Bordeaux" quote="Honnêtement les premiers jours je me suis dit 'bon, encore un truc qui va finir dans le placard.' Mais au bout d'une semaine j'ai passé ma main sur ma cuisse et… c'était différent. Le grain de peau est plus lisse. C'est subtil hein, c'est pas magique. Mais c'est réel." data-id="element-188" />
                <TestimonialCard avatarUrl="https://randomuser.me/api/portraits/women/44.jpg" name="Nathalie" age={44} city="Paris" quote="Bon ce que j'aime surtout c'est que j'ai pas besoin de me forcer. 5 minutes le soir devant ma série, c'est tout. Et franchement la texture de ma peau a changé — plus douce, plus uniforme. Je me sens mieux dans mes fringues et pour moi c'est ça le vrai résultat." data-id="element-189" />
                <TestimonialCard avatarUrl="https://randomuser.me/api/portraits/women/68.jpg" name="Isabelle" age={58} city="Lyon" quote="Après le palper-rouler en institut (douloureux ET cher), j'avais juré que c'était fini. C'est ma fille qui m'a offert le Lissea. Je dois admettre que aucune douleur, zéro bleu, et ma peau est effectivement plus lisse après 3 semaines. Prometteur oui. Et surtout agréable." data-id="element-190" />
                <TestimonialCard avatarUrl="https://randomuser.me/api/portraits/women/41.jpg" name="Valérie" age={41} city="Toulouse" quote="J'ai tout essayé... crèmes, sport, ventouses. Rien tenait parce que c'était soit trop contraignant soit trop douloureux. Le Lissea c'est la première chose que j'utilise vraiment tous les jours. Pourquoi ? Parce que c'est simple et ça me complique pas la vie, point." data-id="element-191" />
              </div>
              <p className="text-center mt-6 italic text-gray-600" data-id="element-192">
                Remarquez quelque chose ? Aucune ne parle de miracle. Elles
                parlent de texture, de douceur, de confort et de simplicité.
              </p>
            </ContentSection>

            <ContentSection data-id="element-193">
              <h2 className="text-2xl md:text-3xl font-sans font-bold text-gray-900 mt-16 mb-8" data-id="element-194">
                Vos questions, nos réponses honnêtes
              </h2>
              <div className="bg-white border border-gray-200 rounded-2xl p-2 md:p-6" data-id="element-195">
                <FAQItem question="Combien de temps avant de voir des résultats ?" answer="La plupart des utilisatrices remarquent un changement de texture (peau plus douce, plus lisse au toucher) dans les 7 à 14 premiers jours d'utilisation régulière. Les résultats visuels sur l'aspect de la peau se développent progressivement avec la constance — généralement entre 3 et 6 semaines." data-id="element-196" />
                <FAQItem question="Est-ce que ça fait mal ?" answer="Non. Lissea™ utilise des micro-vibrations — pas de l'aspiration, pas de la pression, pas du palper-rouler. Il n'y a aucune douleur, aucun bleu, aucun risque d'éclater des petits vaisseaux. Beaucoup de femmes décrivent la sensation comme agréable, presque relaxante." data-id="element-197" />
                <FAQItem question="J'ai déjà essayé ce genre d'appareil et ça n'a rien donné." answer="C'est compréhensible. La plupart des appareils grand public reposent sur l'aspiration ou la pression — des mécanismes qui agressent la peau sans traiter le problème de fond. Lissea™ fonctionne différemment : les micro-vibrations stimulent en douceur, ce qui permet une utilisation quotidienne réelle." data-id="element-198" />
                <FAQItem question="Est-ce que c'est dangereux pour la circulation ou les vaisseaux ?" answer="Non. Contrairement aux ventouses et aux appareils à aspiration, Lissea™ n'exerce aucune pression négative sur la peau. Les micro-vibrations sont douces et non-invasives. (Si vous avez un problème circulatoire diagnostiqué, consultez votre médecin avant utilisation)." data-id="element-199" />
                <FAQItem question="Est-ce que les résultats durent, ou est-ce que ça revient dès qu'on arrête ?" answer="Soyons francs : aucune méthode ne donne de résultats permanents et définitifs sur la cellulite. C'est précisément pour ça que Lissea™ est conçu comme un rituel quotidien, pas comme un traitement ponctuel. L'entretien fait partie du processus — mais quand le rituel ne prend que 5 minutes et ne fait pas mal, le maintenir devient naturel." data-id="element-200" />
              </div>
            </ContentSection>

            <ContentSection id="offer" data-id="element-201">
              <h2 className="text-3xl md:text-4xl font-sans font-extrabold text-gray-900 mt-16 mb-8 text-center" data-id="element-202">
                Ce que vous recevez aujourd'hui
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/jfkf6KTW9MiHgy67xoPjSB/hf_20260313_145131_72315473-aaf3-4281-938f-7c51f15e394d.jpg" alt="Lissea en action" className="w-full h-auto rounded-2xl shadow-md mb-10 object-cover" data-id="element-203" />

              <div className="bg-white border-2 border-brand-100 rounded-2xl p-6 md:p-10 shadow-xl shadow-brand-100/50" data-id="element-204">
                <OfferItem title="Le Lissea™ — Appareil à Micro-Vibrations" description="L'appareil lui-même. Ergonomique, léger, rechargeable. Conçu pour être utilisé confortablement sur les cuisses, le ventre, les bras et les fesses. Plusieurs niveaux d'intensité." data-id="element-205" />
                <OfferItem title="Le Protocole Texture — Guide de Rituel" description="Un guide clair, étape par étape, qui vous montre exactement comment utiliser Lissea™ pour des résultats optimaux. Quelles zones cibler, dans quel ordre, combien de temps." data-id="element-206" />
                <OfferItem title="Le Calendrier de Suivi 60 Jours" description="Un outil de suivi qui vous permet de noter vos sensations jour après jour. Parce que les changements de texture sont progressifs et parfois subtils au début." data-id="element-207" />
                <OfferItem title="Le Guide 'Gestes Complémentaires'" description="Des conseils simples et réalistes (hydratation, mouvements doux) qui complètent l'action de Lissea™ — sans transformer votre vie en programme wellness à plein temps." data-id="element-208" />

                <PriceComparison data-id="element-209" />

                <div className="mt-10 text-center" data-id="element-210">
                  <CTAButton fullWidth className="py-5 text-xl" data-id="element-211">
                    Essayer Lissea™ — Satisfaite ou Remboursée
                  </CTAButton>
                  <p className="font-sans text-sm text-gray-500 mt-4" data-id="element-212">
                    Paiement 100% sécurisé. Expédition en 24/48h.
                  </p>
                </div>
              </div>
            </ContentSection>

            <GuaranteeSection data-id="element-213" />

            <ContentSection data-id="element-214">
              <h2 className="text-2xl md:text-3xl font-sans font-bold text-gray-900 mt-16 mb-6" data-id="element-215">
                Le vrai choix
              </h2>
              <p data-id="element-216">Vous avez deux options en ce moment.</p>
              <p data-id="element-217">
                <strong data-id="element-218">Option 1 :</strong> Vous fermez cette page. Vous
                continuez comme avant. Les crèmes. Les tentatives. Les
                déceptions. Et peut-être, dans quelques mois, vous vous
                retrouverez à chercher "solution cellulite" sur Internet, en
                espérant que cette fois, quelque chose sera différent.
              </p>
              <p data-id="element-219">
                <strong data-id="element-220">Option 2 :</strong> Vous essayez Lissea™ — protégée par
                une garantie complète de 60 jours. Vous suivez le Protocole
                Texture. Et dans une à deux semaines, vous passez votre main sur
                votre peau… et vous sentez la différence sous vos doigts.
              </p>
              <p data-id="element-221">Pas une promesse. Une sensation réelle.</p>
              <p data-id="element-222">
                Et à partir de cette sensation, quelque chose change — pas
                seulement dans votre peau, mais dans la façon dont vous vous
                sentez dans votre corps. Dans vos vêtements. Devant votre
                miroir.
              </p>
              <p data-id="element-223">
                La question n'est pas de savoir si Lissea™ peut fonctionner
                pour vous. La question, c'est :{' '}
                <strong data-id="element-224">
                  est-ce que vous êtes prête à vous donner 60 jours pour le
                  découvrir ?
                </strong>
              </p>

              <div className="mt-10 mb-16 text-center" data-id="element-225">
                <CTAButton className="py-5 px-10 text-xl" data-id="element-226">
                  Oui, je veux essayer Lissea™ →
                </CTAButton>
                <p className="font-sans font-medium text-brand-700 mt-4" data-id="element-227">
                  Garantie Satisfaite ou Remboursée 60 jours. Sans condition.
                  Sans risque.
                </p>
              </div>
            </ContentSection>

            <ContentSection className="border-t border-gray-200 pt-10" data-id="element-228">
              <p className="text-gray-600 text-base" data-id="element-229">
                <strong data-id="element-230">P.S.</strong> — Si vous hésitez encore, rappelez-vous
                ceci : la différence entre Lissea™ et tout ce que vous avez
                essayé avant, ce n'est pas la puissance. C'est la simplicité.
                Les femmes qui obtiennent des résultats ne sont pas celles qui
                ont le plus de discipline — ce sont celles qui ont trouvé
                quelque chose d'assez simple pour être utilisé tous les jours.
                Lissea™ a été conçu pour être cette chose-là.
              </p>
              <p className="text-gray-600 text-base mt-4" data-id="element-231">
                <strong data-id="element-232">P.P.S.</strong> — Vous ne risquez rien. Littéralement.
                Si dans 60 jours vous ne sentez aucune différence, un simple
                email suffit pour être remboursée. La seule chose que vous
                risquez, c'est de passer votre main sur votre cuisse dans deux
                semaines et de sourire.
              </p>
            </ContentSection>
          </div>
        </article>

        {/* Desktop Sticky Sidebar */}
        <aside className="hidden lg:block w-80 shrink-0" data-id="element-233">
          <FloatingProduct data-id="element-234" />
        </aside>
      </main>

      <footer className="bg-gray-50 border-t border-gray-200 py-12 mt-12" data-id="element-235">
        <div className="max-w-5xl mx-auto px-4 text-center font-sans text-gray-500 text-sm" data-id="element-236">
          <p data-id="element-237">© {new Date().getFullYear()} Barkvee. Tous droits réservés.</p>
          <p className="mt-2" data-id="element-238">
            Ce site n'appartient pas à Facebook et n'est pas affilié à Facebook
            Inc.
          </p>
        </div>
      </footer>
    </div>;
}